import React from "react";
import { I18n } from "@lingui/react";
import {
  SecondaryNav as Navigation,
  SecondaryNavItem,
  Thirds,
  Center,
  ControlGroup,
} from "@conserveit/blocks";
import { history } from "../../../browserHistory";
import { Link } from "../../../utils/routes/index";
import { navigate } from "../../../utils/routes/navigate";

SecondaryNavItem.defaultProps = {
  isActive: false,
};

interface Props {
  links: Link[];
  hasBottomBorder?: boolean;
}

export const SecondaryNav: React.FunctionComponent<Props> = ({
  links,
  hasBottomBorder = true,
}) => {
  return (
    <I18n>
      {({ i18n }) => (
        <Navigation hasBottomBorder={hasBottomBorder}>
          <Thirds>
            <Center>
              <ControlGroup tight>
                {links.map(({ href, label }) => (
                  <SecondaryNavItem
                    key={href}
                    onClick={navigate(href)}
                    isActive={history.location.pathname.startsWith(href)}
                  >
                    {label(i18n)}
                  </SecondaryNavItem>
                ))}
              </ControlGroup>
            </Center>
          </Thirds>
        </Navigation>
      )}
    </I18n>
  );
};
